/* eslint-disable no-console */
import {Row} from 'antd';
import React from 'react';

import useJSONStore from '../../../store/StaticJson/jsonStore';
import {
  hasAccessToReport,
  shouldBlockReportAccess
} from '../../../utils/SubscriptionHelper';
import {
  handleIsComingSoonConditionally,
  sortFrameworkByIsComingSoonAndHideUnauthorizedReports
} from '../constants/commonFunctions';
import {FrameworkObj} from '../constants/FrameWorksConst';

import Framework from './Framework';

const Frameworks: React.FC = () => {
  const pillarData = useJSONStore?.getState().esgPillars;

  const frameworkObjSorted =
    sortFrameworkByIsComingSoonAndHideUnauthorizedReports(
      FrameworkObj?.map((item) => {
        return {
          ...item,
          isComingSoon:
            !hasAccessToReport(item?.route) ||
            handleIsComingSoonConditionally(item.route, item.isComingSoon)
        };
      })
    );

  return (
    <Row gutter={[16, 16]}>
      {frameworkObjSorted?.map((item, index) => {
        return (
          <Framework
            item={item}
            key={index}
            isBlock={shouldBlockReportAccess(item?.route)}
            data={pillarData?.find((pItem: any) => {
              return pItem?.name === item?.title;
            })}
          />
        );
      })}
    </Row>
  );
};

export default Frameworks;
